import * as CubeTree from '../../cubeTree';
import * as UIToolkit from '../../UIToolkit';
import FrontCubeData from '../../frontCubeData';
import Utils from '../../utils/util';
import { getColWidth } from './getColWidth';

function findOverFlowCols(freezer: CubeId): CubeId[][] {
    let result: CubeId[][] = [];
    let freezerCubes: CubeId[] = CubeTree.findCubesInFreezer(freezer, []);
    let cols: CubeId[][] = UIToolkit.makeSkuCubesColGroupList(freezerCubes);
    let freezerWidth: PhysicsMeasurement = FrontCubeData.getNumberValue(freezer, 'width');

    cols.forEach((col: CubeId[]): void => {
        let left: PhysicsMeasurement = FrontCubeData.getNumberValue(col[0], 'posX');

        // 左侧越界一定溢出
        if (left >= freezerWidth) {
            result.push(col);
            return;
        }

        let colWidth: PhysicsMeasurement = getColWidth(col);
        let rightLine: PhysicsMeasurement = Utils.math(left, colWidth, '+');
        let half: PhysicsMeasurement = Utils.math(colWidth, 2, '/');
        let overflow: PhysicsMeasurement = Utils.math(rightLine, freezerWidth, '-');

        // 需要判断是否宽度一般越界
        if (rightLine > freezerWidth && overflow >= half) {
            result.push(col);
        }
    });

    return result;
}

export {
    findOverFlowCols
};
